import { IMail, IMailroom } from '@commenda/api';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';
import { generateGmailLink } from '@commenda/utils';

type GetHelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mail: IMail & { mailroom: IMailroom };
};

const GetHelpModal = ({ isOpen, onClose, mail }: GetHelpModalProps) => {
  const handleClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    const mailtoLink = generateGmailLink(
      'operations@commenda.io',
      'Support Request - Mailroom',
      ''
    );
    
    window.open(mailtoLink, '_blank');
    handleClose();
  };
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => !open && handleClose()}
    >
        <DialogContent preventCloseOnOutsideClick className="max-w-[500px]">
          <DialogHeader className="flex flex-col items-start">
            <DialogTitle>Contact Support</DialogTitle>
          </DialogHeader>

          <div className="p-6">
            <p className="text-text-tertiary">
              Need help with your mailroom? Click below to send us an email and we'll get back to you as soon as possible.
            </p>
          </div>

          <DialogFooter>
            <DialogClose asChild>
              <Button variant="secondary">
                Cancel
              </Button>
            </DialogClose>
            <Button
              variant="primary"
              onClick={handleSubmit}
            >
              <Icons.Send01 className="size-4" />
              Mail us
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export { GetHelpModal };